import { Stack, Typography } from '@mui/material'
import { useAuthContext } from 'context/AuthContext'
import moment from 'moment'

import { theme } from 'styles/theme'

import * as S from './Welcome.styles'

export const getMonth = () => {
  const string = Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(
    moment(new Date()).toDate()
  )

  return string.charAt(0).toUpperCase() + string.slice(1)
}

function greeting() {
  const now = new Date()
  const hours = now.getHours()
  const minutes = now.getMinutes()

  if (hours >= 5 && (hours < 12 || (hours === 12 && minutes === 0))) {
    return 'Bom dia'
  } else if (hours >= 12 && (hours < 18 || (hours === 17 && minutes <= 59))) {
    return 'Boa tarde'
  } else {
    return 'Boa noite'
  }
}

const Welcome = () => {
  const { user } = useAuthContext()

  return (
    <S.Wrapper>
      <Stack direction="column" alignItems="center" gap="8px">
        <Typography
          variant="mdLight"
          sx={{ color: theme.palette.neutral[400], fontSize: '15px' }}
        >
          {greeting()}, {user?.merchant_user_name} {'👋'}
        </Typography>
        <S.GradientTitle>Como posso te ajudar hoje?</S.GradientTitle>
      </Stack>
    </S.Wrapper>
  )
}

export default Welcome
